import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=7041db6d&"
import script from "./AcceptTerms.vue?vue&type=script&lang=ts&"
export * from "./AcceptTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports